export var RESIZABLE_COLUMNS_CLASS = 'awsui-table-resizable-columns';
export var RESIZABLE_COLUMNS_ACTIVE_CLASS = RESIZABLE_COLUMNS_CLASS + "-active";
export var RESIZABLE_COLUMNS_RESIZER_CLASS = RESIZABLE_COLUMNS_CLASS + "-resizer";
export var RESIZABLE_COLUMNS_TRACKER_CLASS = RESIZABLE_COLUMNS_RESIZER_CLASS + "-tracker";
export var RESIZABLE_COLUMNS_DRAGGING_CLASS = RESIZABLE_COLUMNS_RESIZER_CLASS + "-dragging";
export var INITIAL_WIDTH = 120;
export var INITIAL_MIN_WIDTH = 120;
export var AUTO_EXPANDING_WIDTH = 5;
export var TABLE_SELECTION_WIDTH = 54;
//# sourceMappingURL=constants.js.map